module.exports = __webpack_public_path__ + "img/info.79b96998.svg";